import styled from 'styled-components';

export const Timer = styled.p`
  margin: 0;
  margin-bottom: 35px;
  padding: 0;
  
  font-size: 12px;
  line-height: 1;
  color: #a7a7a7;
  
  @media(min-width: 768px) {
    font-size: 16px;
  }
  
  @media(min-width: 1024px) {
    margin-bottom: 0;
  }
  
  span {
    font-weight: 700;
    color: ${({ theme }) => theme.blue};
  }
`;
